import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=6ff1ce80&scoped=true"
import script from "./CommonTab.vue?vue&type=script&lang=ts"
export * from "./CommonTab.vue?vue&type=script&lang=ts"
import style0 from "./CommonTab.vue?vue&type=style&index=0&id=6ff1ce80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff1ce80",
  null
  
)

export default component.exports